import { render, staticRenderFns } from "./DAudioUploadEditor.vue?vue&type=template&id=e0620596&"
import script from "./DAudioUploadEditor.vue?vue&type=script&lang=js&"
export * from "./DAudioUploadEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports